import { FlowConditionAppZapierNew } from './types.flow';
import { FLOW_CONDITION_TYPES } from '../constants';
import { emptyStringPrimitiveParameterValue } from '../../FlowParameter';

export default (): Omit<FlowConditionAppZapierNew, 'id'> => ({
  type: FLOW_CONDITION_TYPES.EVENT_CONTACT_APP_ZAPIER_NEW.type,
  zapierEventId: emptyStringPrimitiveParameterValue(),
});
